import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
export function IncludesSection() {
  return <section className="py-16 md:py-24 bg-white px-5 border-b border-gray-100" data-id="element-124">
      <div className="max-w-5xl mx-auto" data-id="element-125">
        <div className="text-center mb-12 md:mb-16" data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 tracking-tight" data-id="element-127">
            🥗 ¿Qué incluye este manual?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-128">
            Todo lo necesario para tu transformación
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100 relative" data-id="element-129">
          {/* Gradient bar */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-500 to-amber-400" data-id="element-130"></div>

          <div className="p-6 md:p-16 relative z-10" data-id="element-131">
            <div className="space-y-8 md:space-y-0 md:grid md:grid-cols-2 md:gap-y-10 md:gap-x-16" data-id="element-132">
              {['Más de 800 recetas antiinflamatorias para la menopausia', 'Desayunos, almuerzos, cenas y snacks hormonalmente equilibrados', 'Recetas fáciles, ricas y pensadas para tu etapa', 'Protocolos de biohacking para la pre y postmenopausia', 'Planes para mejorar energía, digestión y metabolismo hormonal', 'Guías para equilibrar estrógenos, progesterona y glucosa'].map((item, index) => <div key={index} className="flex items-start gap-6 group/item" data-id="element-133">
                  <div className="bg-emerald-100 p-2.5 rounded-full shrink-0 mt-0.5 group-hover/item:bg-emerald-200 transition-colors shadow-sm group-hover/item:scale-110 duration-300" data-id="element-134">
                    <Check className="w-6 h-6 text-emerald-700" strokeWidth={3} data-id="element-135" />
                  </div>
                  <span className="text-xl text-gray-800 font-medium leading-relaxed group-hover/item:text-emerald-900 transition-colors" data-id="element-136">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="mt-12 md:mt-16 pt-8 md:pt-12 border-t border-gray-100 text-center" data-id="element-137">
              <p className="text-lg md:text-xl text-gray-600 mb-8 font-serif italic" data-id="element-138">
                Todo explicado paso a paso y pensado para la vida real.
              </p>

              <a href="https://checkot2.descargatop.com/cart/50167803609445:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-emerald-600 hover:bg-emerald-700 text-white text-xl font-bold py-6 px-14 rounded-full shadow-lg hover:shadow-emerald-500/40 transition-all transform hover:-translate-y-1 group border border-emerald-500/20" data-id="element-139">
                <span data-id="element-140">ACCEDER CON DESCUENTO</span>
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-141" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}